module.exports = __webpack_public_path__ + "img/hx_3.fc4c7025.jpg";